export default __webpack_public_path__ + "static/media/follow-light-grey.10171254.svg";